import { render, staticRenderFns } from "./activeListWtxh.vue?vue&type=template&id=09b5c604&scoped=true"
import script from "./activeListWtxh.vue?vue&type=script&lang=js"
export * from "./activeListWtxh.vue?vue&type=script&lang=js"
import style0 from "./activeListWtxh.vue?vue&type=style&index=0&id=09b5c604&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09b5c604",
  null
  
)

export default component.exports